<template>
    <div style="margin-bottom:0px">
        <el-input ref="generalsearch" clearable width="100%" placeholder="查询" @focus="focused" @blur="blured"
            v-model="targettxt" @keyup.enter.native="callfetchdata">
            <el-button @click="callfetchdata" slot="append" icon="el-icon-search"></el-button>
            <el-button v-bind:style="{ background: searchmodel.filter ? '#64fa93' : '#F5F7FA' }" slot="append"
                @click="searchmodelswitch('filter')" icon="el-icon-more"></el-button>
            <el-button v-bind:style="{ background: searchmodel.api ? '#64fa93' : '#F5F7FA' }" v-if="apisource"
                slot="append" @click="searchmodelswitch('api')">API</el-button>
        </el-input>

        <transition name="fade">
            <div style="" v-show="toshowfilter">
                <apinsearch v-if="searchmodel.api" caller="filterbox"></apinsearch>
                <filterbox @filterdone="searchboxreset" v-if="searchmodel.filter && toshowfilter"></filterbox>
            </div>
        </transition>
    </div>
</template>
<script>
import filterbox from "./filterbox_filter.vue"
import apinsearch from "@/components/exceltodb/defineddb_json_api"

export default {
    components: {
        filterbox, apinsearch
    },
    data() {
        return {
            searchmodel: { api: false, filter: false },
            toshowfilter: false
        }
    },
    computed: {
        apisource() {
            return this.$store.state.collection.apisource
        },

        targettxt: {
            get: function () {
                return this.$store.state.targettxt;
            },
            set: function (val) {
                this.$store.commit("settargettxt", val);
            },
        },
    },


    methods: {
        resetsearch() {
            this.searchmodel = { api: false, filter: false }
            this.$refs.generalsearch.focus()

        },
        searchmodelswitch(model) {

            if (this.searchmodel[model]) {
                this.searchmodel[model] = false
            }
            else {
                this.toshowfilter = true
                this.searchmodel = { api: false, filter: false }
                this.searchmodel[model] = true
                this.$emit("searchstatus", "search")
            }
        },
        searchstatus(status) {
            this.$emit("searchstatus", status)
        },
        blured() {
            // this.searchstatus("normal")
            // this.toshowfilter=false
        },
        searchboxreset() {
            this.searchstatus("normal")
            this.toshowfilter = false
        },
        focused() {
            this.searchstatus("search")
            this.toshowfilter = true
        },
        callfetchdata() {
            this.toshowfilter = false
            this.searchstatus("normal")
            this.$store.commit("setsearchmodel", "generalsearch")
            this.$store.commit("setpage", 1);
            this.$axios.fetchdata();
      

        },
    }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/presentation/table/searchgroup.vue